export default {"src":"/_next/static/media/icon-60-years-logo.7263116e.svg","height":34,"width":93,"blurWidth":0,"blurHeight":0};